













































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Order } from '@/models/order';
import formatNumber from '@/shared/filters/format-number';

@Component
export default class AmountDetailOrder extends Vue {
    @Prop({ default: () => new Order() })
    private order!: Order;

    get deposit() {
        if (!this.order) { return '0'; }
        if (this.order.deposit === 0) {
            return '<span class="text-slate-400 font-medium">Chưa đặt cọc</span>';
        }
        return formatNumber(this.order.deposit, '0,0') + ' đ';
    }

    get feeBuyDiscount() {
        if (this.order.feeBuyDiscount > 0) {
            return (this.order.feeBuyDiscount / 100) * this.order.feeBuyAmount;
        }
        return 0;
    }

    get needPayment() {
        if (!this.order) { return 0; }
        return this.order.totalAmountVND - this.order.deposit;
    }
}
